

<h1 class="page-header">Unsubscribe to Newsletter</h1>

<section class="bg-light">
  <div class="container">
    @if (showForm) {
      <div class="row">
        <div class="col-md-4 mb-4">
          <form (ngSubmit)="onSubmit()">
            <div class="mb-3">
              <input type="email" name="email" [(ngModel)]="email" class="form-control"
                placeholder="Your email address" required>
            </div>
            <button type="submit" class="btn btn-primary w-100">Subscribe</button>
          </form>
        </div>
      </div>
    }

    @if (successMessage) {
      <div class="row">
        <div class="col-xs-12" style="height:50px;"></div>
        <p class="alert alert-success text-center">{{ successMessage }}</p>
        <div class="text-center">
          <button class="btn btn-secondary" (click)="goBack()">Go Back</button>
        </div>
        <div class="col-xs-12" style="height:50px;"></div>
      </div>
    }
  </div>
</section>
